import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massRestoreSliders } from '../../api/apiSliders';
import toast from 'react-hot-toast';

export const useMassRestoreSliders = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massRestoreSliders,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['sliders'] });
            toast.success(data.message || 'Sliders restored successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to restore sliders';
            toast.error(errorMessage);
        },
    });
};